export default __webpack_public_path__ + "static/media/edelweiss.138f50a6.png";